<template>
  <div>
    <el-card
      style="max-width: 500px; width: 100%; height: 50vh; overflow-y: auto"
    >
      <el-card-section>
        <div class="text-h6">隐私政策</div>
        <el-space />
        <el-btn icon="close" flat round dense @click="showModal = false" />
      </el-card-section>

      <el-card-section class="custom-list">
        <!-- 内容区域 -->
        <h5>重要提示</h5>
        <ol>
          <li>
            我们深知个人信息对您的重要性。我们会严格按照相关法律法规及本公司隐私政策（下称“本隐私政策”）的规定收集、使用、储存和分享（以下通称“处理”）您的个人信息。本隐私政策适用于我们向您提供的各项产品及服务。本隐私政策旨在说明，在您使用我们的产品或服务时，我们如何处理您的个人信息，以及您如何可以访问、更新或删除这些信息等。
          </li>
          <li>
            在使用我们的产品或服务前，请务必仔细阅读并充分理解本隐私政策。一旦您开始使用我们的产品或服务，或者向我们提交个人信息，则表示您知晓本隐私政策的全部条款并且完全同意我们依据本隐私政策对这些信息的处理。
          </li>
          <li>
            我们提供产品或服务的网络平台（包括但不限于数据库、官网、移动APP）可能包含跳转至其他网站的链接或指引。请注意，我们不控制这些网站，本隐私政策在任何情况下均不适用于这些网站。我们建议您在访问这些网站时仔细阅读他们的隐私政策。
          </li>
          <li>
            如对本隐私政策内容有任何疑问、意见或建议，您可按照本隐私政策第九条显示的任一联系方式与我们联系。
          </li>
        </ol>

        <h5>定义</h5>
        <ul>
          <li>
            <strong>您：</strong
            >指使用我们产品或服务的个人，包括通过机构客户名下账号使用我们产品或服务的个人。
          </li>
          <li>
            <strong>我们：</strong
            >指产品或服务的提供者无锡奥特维科技股份有限公司（或称“奥特维”）。
          </li>
          <li>
            <strong>产品或服务：</strong
            >指我们通过包括但不限于电脑、移动智能终端等渠道提供的法律、财税、人力、医疗等专业领域的数据库信息浏览、查询、下载等服务。
          </li>
          <li>
            <strong>个人信息：</strong
            >是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，包括姓名、身份证件号码、通信通讯联系方式、住址、账号密码、财产状况、行踪轨迹等。
          </li>
        </ul>

        <h5>我们如何收集和使用您的信息</h5>
        <p>
          在您使用我们产品或服务的过程中，我们仅会在非常必要的情况下和非常有限的限度内收集您的个人信息，并且这些信息仅用于向您提供产品或服务、优化我们的产品或服务，以及保障您的账号安全。具体而言，我们将按照如下方式收集您主动提供或因为使用产品和服务而产生的信息：
        </p>
        <ol>
          <li>
            在您使用我们的产品或服务过程中，我们可能还会收集您所属单位名称、部门、职务、单位规模及所处行业等信息。这些信息有助于我们更好地进行营销研究分析，以便向您提供更好的服务。您可以决定是否提供这些信息，不提供这些信息不会影响使用我们的产品和服务。
          </li>
          <li>
            我们可能会使用您的联系信息向您推送问卷调查、活动邀请、商业广告等信息。如果您不想接收这些信息，可在收到上述邮件后，随时按邮件说明退订，也可以通过pr@wxautowell.com与我们联系进行退订。
          </li>
          <li>
            当您与我们联系或我们主动通过问卷调查、电话征求您的使用建议或意见时，我们可能会保存您的通信/通话记录和内容等信息，该等信息用于帮助我们改进服务/回应用户的问题。除非相关法律另有规定外，这些信息不应被视为具有保密性。
          </li>
          <li>
            当您使用我们的产品或服务时，您的某些信息，包括但不限于您使用设备的型号、唯一标识号、操作系统、浏览器类型、显示器分辨率、互联网协议地址、域名、网页、访问网站时间和时长、使用服务时所访问的页面，可能会通过互联网协议地址、cookies、网址标签以及导航数据采集等各种技术和方法被采集（即在您非主动提供信息的情况下进行收集）并记入服务器日志文件。我们可能会使用这些信息作数据统计分析，以便改进我们的服务和营销。
          </li>
          <li>
            我们的网站采用互联网协议（IP）地址技术。IP地址是互联网服务提供商分配给您电脑的一个编号，以便您能访问互联网。多数情况下IP地址是动态的（每次接入互联网时都发生变化），而不是静态的（与用户电脑一一对应），因此IP地址通常不被视为个人身份验证信息。我们使用您的IP地址用于诊断服务器故障、报告信息、确定您的电脑和本站连接能使用的最快路径以及对网站进行管理和改进。
          </li>
          <li>
            “cookie”是网站向您的浏览器发送的少量信息，以帮助网站记住有关您及您偏好的信息。
          </li>
          <li>
            “会话cookies”是一些暂时的信息，当您退出浏览器窗口或关闭计算机时将自动删除。会话cookies用于改进网站的导航并收集统计信息。
          </li>
          <li>
            “持久cookies”是一些更持久的信息，如果不删除则会始终存放在您的电脑硬盘中。持久cookies在您的电脑上储存信息有若干目的，如：找回您曾经提交的某些信息（如密码）、帮助确定网站访问者认为最有价值的区域、基于您的偏好对网站进行定制等。我们的网站使用cookies的主要目的是储存您的默认偏好。
          </li>
          <li>
            您可以将浏览器设置为收到cookie时立即通知您，以便您决定是否接受它。
          </li>
          <li>
            您也可以将浏览器设置为完全禁止储存cookies，但必须提醒您的是这将可能会妨碍您对我们网站或服务的使用。如欲了解有关cookies的更多信息，敬请访问www.cookiecentral.com/faq。
          </li>
          <li>
            目前我们不会主动收集本隐私政策明示以外的信息包括从第三方获取您的个人信息。如未来为业务发展需要收集该类个人信息，我们会在获取前征得您的明示同意，从第三方获取您的个人信息，我们会要求第三方保障其提供的信息的合法性。
          </li>
          <li>
            我们仅依照法律要求及本隐私政策列明的目的使用您的信息。如需要超出前述目的使用您的个人信息，我们会再次征求您的同意。
          </li>
        </ol>

        <h5>我们如何保护和保存您的信息</h5>
        <ol>
          <li>
            <strong>保护您个人信息的措施：</strong>
            <ol>
              <li>
                我们非常重视个人信息安全，并采取符合业界标准的安全技术措施保护您提供的个人信息安全。
              </li>
              <li>
                我们通过建立专门的管理制度、流程、组织等管理措施以保障信息的安全。例如，我们使用客户信息集中管理系统，我们只允许有必要接触客户信息的工作人员访问该系统查询和管理客户信息，且该系统程序只被允许安装在使用人在办公场所的特定电脑设备上。我们严格设定访问客户信息的权限分级，同时要求可能接触到您个人信息的所有人员履行相应的保密义务。我们还不时对工作人员培训相关法律法规及隐私安全准则，强化宣导安全意识。
              </li>
              <li>
                若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。
              </li>
              <li>
                互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将根据法律规定承担相应的责任。
              </li>
            </ol>
          </li>
          <li>
            <strong>保存您的信息：</strong>
            <ol>
              <li>
                存储地域范围：我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。
              </li>
              <li>
                存储期限：一般而言，我们仅为实现本隐私政策所述目的所必需的时间保留您的个人信息，除非法律要求或允许可以在更长时间内保留这些信息。
              </li>
            </ol>
          </li>
        </ol>

        <h5>我们如何对外提供信息</h5>
        <ol>
          <li>
            我们可能会将您的信息与我们的关联方或合作方共享。奥特维为数据统计分析的需要，在不识别您身份的前提下，可能会整合您使用我们产品或服务的相关信息。另外，我们的客户信息管理系统和订单管理系统可能由第三方服务供应商（以下称“供应商”）管理和维护，您的信息可能会被供应商接触，我们会与供应商签署严格的数据保护协定，要求他们按照法律规定、本隐私政策以及其他任何相关的保密要求，以不低于我们的安全措施标准来处理您的个人信息。
          </li>
          <li>
            除了我们可能在适用法律、法院命令或政府法规的要求下披露您的个人信息以外，未经您的同意，我们不会对外公开披露所获得的您的个人信息。
          </li>
          <li>
            随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知您相关情形，按照法律法规及不低于本隐私政策所要求的标准继续保护或确保新的控制者继续保护您的个人信息。
          </li>
        </ol>

        <h5>如何管理您的个人信息</h5>
        <ol>
          <li>
            您可以通过登录您在我们网站开立的账号来查看您提交给我们的个人信息、订单和交易信息、浏览搜索下载内容信息等。
          </li>
          <li>
            为保证您正确身份验证，请及时更新相关信息，以确保它们是准确、最新且完整的，在此过程中如有任何问题，请随时与我们联系。
          </li>
          <li>
            在您注销账号或您的账号到期后，如果您提出申请，我们将根据您的意愿和法律规定将您的个人信息删除或进行匿名化处理。
          </li>
        </ol>

        <h5>未成年人隐私保护</h5>
        <ol>
          <li>
            如您为未成年人的，建议您请您的父母或监护人仔细阅读本隐私权政策，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。
          </li>
          <li>
            对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享或披露信息。
          </li>
        </ol>

        <h5>隐私政策的修订和通知</h5>
        <p>
          由于服务内容、联络方式、法律和监管政策要求等变化，我们可能会适时对本隐私政策进行修订。当隐私政策发生变更时，我们会在我们的官方网站、移动端发布或向您提供的电子邮箱地址发送更新后的版本。为了您能及时接收到通知，建议您在电子邮箱地址变动时及时更新账号信息或通知我们。
        </p>

        <h5>联系我们</h5>
        <p>
          在本隐私政策提及的所有可能需要与我们取得联系的情况下，您可以通过以下方式联系我们：
        </p>
        <ul>
          <li>联系电话：+86-0510-81816658</li>
          <li>电子邮件: pr@wxautowell.com</li>
        </ul>
      </el-card-section>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "CustomerInfoForm2",
  data() {
    return {
      formData: {
        name: "",
        gender: "",
        company: "",
        departmentPosition: "",
        email: "",
        phone: "",
        productOfInterest: "",
      },
      editflag: false,
      status: "submit",
      submittedData: null,
      genderOptions: ["男 (Male)", "女 (Female)", "其他 (Other)"],
      isPrivacyChecked: false,
      showModal: false,
      url: "http://192.168.100.16:16000",
      rules: {
        name: [{ required: true, message: "请输入您的姓名", trigger: "blur" }],
        company: [
          { required: true, message: "请输入您的公司名称", trigger: "blur" },
        ],
        departmentPosition: [
          { required: true, message: "请输入您的部门和职位", trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入有效的邮箱", trigger: "blur" },
          { type: "email", message: "邮箱格式不正确", trigger: "blur" },
        ],
        productOfInterest: [
          { required: true, message: "请输入您感兴趣的产品", trigger: "blur" },
        ],
      },
    };
  },
};
</script>

<style scoped>
.custom-list {
  text-align: left;
}
</style>